import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

export default function FaqSection({ section }) {
  const [open, setOpen] = useState(0);
  const items = section.items || [];
  return (
    <section className="mx-auto max-w-3xl px-6 sm:px-12 py-24" data-testid="faq-section">
      <p className="text-xs uppercase font-mono tracking-[0.3em] text-gold text-center">{section.eyebrow || "FAQ"}</p>
      <h2 className="mt-4 text-3xl sm:text-4xl font-serif font-semibold text-ink text-center">{section.title || "Frequently Asked Questions"}</h2>
      <div className="mt-12 divide-y divide-ink/10 border-y border-ink/10">
        {items.map((item, i) => (
          <div key={i} data-testid={`faq-item-${i}`}>
            <button onClick={() => setOpen(open === i ? -1 : i)} data-testid={`faq-question-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left group">
              <span className="font-serif text-lg text-ink group-hover:text-gold transition-colors">{item.q}</span>
              <ChevronDown size={18} className={`shrink-0 text-gold transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
            </button>
            <AnimatePresence initial={false}>
              {open === i && (
                <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }} className="overflow-hidden">
                  <p className="pb-6 text-sm sm:text-base text-ink2 leading-relaxed" data-testid={`faq-answer-${i}`}>{item.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </section>
  );
}
